import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../atoms';

import { PlanSummaryColumns } from './PlanSummaryColumns';

export const DentalCareSection = () => {
  const { t } = useLingui();
  const currentPlan = useAtomValue(selectedPlanAtom);

  const benefitSummary = currentPlan?.benefitSummary;
  const remainingBenefits = benefitSummary?.remainingBenefits ?? 0;
  const totalBenefits = benefitSummary?.totalBenefits ?? 0;
  const remainingDeductible =
    benefitSummary?.deductible?.remainingDeductible ?? 0;
  const totalDeductible = benefitSummary?.deductible?.totalDeductible ?? 0;
  const isDeductibleMet = benefitSummary?.deductible?.status === 'Met';

  return (
    <PlanSummaryColumns
      benefitsTitle={t`DENTAL BENEFITS REMAINING`}
      remainingBenefits={remainingBenefits}
      totalBenefits={totalBenefits}
      hideBenefitsProgress={remainingBenefits === 0}
      benefitsChip={
        remainingBenefits === 0 && totalBenefits > 0
          ? {
              text: t`Benefits Exhausted`,
              variant: 'error',
              icon: <FontAwesomeIcon icon={faExclamationTriangle} />,
            }
          : undefined
      }
      deductibleTitle={t`DEDUCTIBLE REMAINING`}
      remainingDeductible={remainingDeductible}
      totalDeductible={totalDeductible}
      isDeductibleMet={isDeductibleMet}
      noDeductibleMessage={t`No deductible`}
    />
  );
};
